export default __webpack_public_path__ + "static/media/blue-logo.5cd29d16.svg";